import { atom } from 'recoil';

import type { User } from '../../../types';

export const usersState = atom<User[]>({
  key: 'users',
  default: [],
});
